export default "__VITE_ASSET__937e8fa1__"